import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-63628b30"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
import { usePageConfig } from '@/utils/useComponentConfig';
import { useRouter } from 'vue-router';
import { debounce, deepCloneByJSON } from '@/utils/tools';
import { onMounted, ref } from 'vue';
import { messageBox } from "@/utils/validate";
import { elMessage } from '@/utils';
import { clearData } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { getCurrentTime } from "@/utils/timeFormat";
import { getDynamicTopicListApi, deleteDynamicTopicListApi } from '@/api/topic';
import EditTemplate from './editTemplate.vue';
import NewTopic from './NewTopic.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    onMounted(() => {
      getData();
    });
    const router = useRouter();
    const tableRef = ref(null);
    const temObj = ref({
      visible: false,
      data: null,
      clientType: 'Phone'
    });
    const searchConfig = reactive({
      formData: {
        name: undefined
      },
      formList: [{
        label: '关键字',
        prop: 'name',
        widgetType: 'input'
      }],
      search: () => {}
    });
    const tableConfig = reactive({
      data: [],
      paginationConfig: usePageConfig(),
      isShowHeader: true,
      scrollbarAlwaysOn: true,
      listName: '主题管理',
      headerButtonsList: [{
        label: '新增',
        func: () => {
          newTopic.visible = true;
          newTopic.action = 'add';
          newTopic.data = {};
        }
      }],
      columnList: [//   { label: '序号', prop: 'no', width: 150 },
      {
        label: '主题名称',
        prop: 'name',
        sortable: 'custom',
        width: 300
      }, {
        label: '主题类型',
        prop: 'type',
        sortable: 'custom',
        width: 150,
        formatter: val => val == 'fixed' ? t('固定') : t('运营')
      }, {
        label: '终端',
        prop: 'clientType',
        sortable: 'custom',
        width: 150,
        formatter: val => val == 'phone' ? 'Phone' : 'STB'
      }, {
        label: '是否4K',
        prop: 'is4k',
        width: 120,
        formatter: val => val == 1 ? t('是') : t('否')
      }, {
        label: '关联方案',
        prop: 'relatedVodList',
        sortable: 'custom',
        formatter: val => {
          return val.length ? val.join(',') : '';
        }
      }, {
        label: '描述',
        prop: 'description',
        width: 200
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        width: 200
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        showOverflowTooltip: false,
        fixed: 'right',
        buttonsList: [{
          label: '修改',
          func: data => {
            newTopic.data = deepCloneByJSON(data);
            newTopic.visible = true;
            newTopic.action = 'edit';
          },
          // 已关联 Launcher 时二次确认
          popConfirm: row => {
            if (!row.relatedVodList || !row.relatedVodList.length) return null;
            return {
              title: t('主题已关联方案，修改主题将同步变更关联的方案，确定修改？'),
              confirmText: t('确定'),
              cancelText: t('取消')
            };
          }
        }, {
          label: '编辑模板',
          func: data => {
            temObj.value.visible = true;
            temObj.value.data = data;
            temObj.value.clientType = data.clientType;
          },
          // 已关联 Launcher 时二次确认
          popConfirm: row => {
            if (!row.relatedVodList || !row.relatedVodList.length) return null;
            return {
              title: t('主题已关联方案，修改主题将同步变更关联的方案，确定修改？'),
              confirmText: t('确定'),
              cancelText: t('取消')
            };
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              const {
                id
              } = row;
              const {
                code
              } = await deleteDynamicTopicListApi(id);

              if (code == 0) {
                elMessage('success', '删除成功');
                getData();
              }
            });
          },
          controller: row => {
            return !row.relatedVodList || !row.relatedVodList.length;
          }
        }]
      }],
      config: {
        loading: false
      }
    });
    const newTopic = reactive({
      visible: false,
      action: 'check',
      data: {}
    }); //新增主题按钮

    const addTopic = () => {
      newTopic.visible = true;
      newTopic.action = 'add';
      newTopic.data = {};
    }; // 获取主题列表


    const getData = async params => {
      const {
        page,
        limit
      } = tableConfig.paginationConfig;
      tableConfig.config.loading = true;
      let reqParams = {
        pageNo: tableConfig.paginationConfig.page,
        pageSize: tableConfig.paginationConfig.limit,
        ...params,
        ...sortParams
      };
      const {
        code,
        data
      } = await getDynamicTopicListApi(reqParams);

      if (code == 0) {
        tableConfig.data = data.records ? data.records.map((item, index) => {
          return { ...item,
            createTime: getCurrentTime(item.createTime),
            no: (page - 1) * limit + index + 1
          };
        }) : [];
        tableConfig.paginationConfig = {
          total: data.total,
          limit: data.size,
          page: data.current
        };
      }

      tableConfig.config.loading = false;
    }; // 搜索事件


    const handleSearch = data => {
      tableConfig.paginationConfig.page = 1;
      getData(data);
    }; // 重置按钮事件


    const handleReset = () => {
      tableRef.value.commonTableRef.clearSort();
      tableConfig.paginationConfig.page = 1;
      getData();
    }; // 更新列表


    const updateList = () => {
      clearData(searchConfig.formData);
      getData();
    };

    const sortParams = reactive({
      sortType: undefined,
      sortField: undefined
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      console.log('params', params);

      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getData();
      } else {
        sortParams.sortType = undefined;
        sortParams.sortField = undefined;
        getData();
      }
    }, 200);

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    return (_ctx, _cache) => {
      const _component_SearchForm = _resolveComponent("SearchForm");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_Column = _resolveComponent("Column");

      const _component_CommonTable = _resolveComponent("CommonTable");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_SearchForm, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data"]), _createVNode(_component_CommonTable, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getData,
        options: tableConfig.config,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_Column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [_createVNode(_component_el_popover, {
            placement: "bottom-start",
            width: 150,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("img", {
              class: "logo",
              src: scope.row.layoutImage,
              alt: ""
            }, null, 8, _hoisted_1)]),
            default: _withCtx(() => [_createElementVNode("img", {
              style: {
                "width": "130px",
                "display": "inline-block",
                "text-align": "center"
              },
              src: scope.row.layoutImage,
              alt: ""
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1024)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options", "onSortChange"])], 512), [[_vShow, !temObj.value.visible && !newTopic.visible]]), _createVNode(EditTemplate, {
        modelValue: temObj.value.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => temObj.value.visible = $event),
        data: temObj.value.data,
        clientType: temObj.value.clientType,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "data", "clientType"]), _createVNode(NewTopic, {
        modelValue: newTopic.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => newTopic.visible = $event),
        action: newTopic.action,
        sourceData: newTopic.data,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "action", "sourceData"])], 64);
    };
  }

});